import { Box, Tabs, Tab } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "@store/hooks";
import { selectIsCurrentUserWorkspaceOwner } from "@store/selectors";
import WorkspaceSwitcher from "./WorkspaceSwitcher";
import StudentWorkspaceGrade from "./StudentWorkspaceGrade";

const TAB_BASE = "/workspaces";

interface TabDef {
  label: string;
  value: string;
  ownerOnly?: boolean;
}

const TABS: TabDef[] = [
  { label: "Resources", value: "resources" },
  { label: "Members", value: "members", ownerOnly: true },
  { label: "Settings", value: "settings", ownerOnly: true },
];

const WorkspacesLayout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isOwner = useAppSelector(selectIsCurrentUserWorkspaceOwner);

  const visibleTabs = TABS.filter((t) => !t.ownerOnly || isOwner);

  // Derive the active tab from the URL. Fall back to the first visible tab
  // when the path doesn't match (e.g. an owner-only segment loaded by a
  // non-owner — though RequireAuth gating should prevent this).
  const activeValue =
    visibleTabs.find((t) => pathname.startsWith(`${TAB_BASE}/${t.value}`))
      ?.value ?? visibleTabs[0]?.value;

  const handleChange = (_: unknown, value: string) => {
    navigate(`${TAB_BASE}/${value}`);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <WorkspaceSwitcher />
      {!isOwner && <StudentWorkspaceGrade />}
      <Box sx={{ borderBottom: 1, borderColor: "divider", px: 4 }}>
        <Tabs
          value={activeValue}
          onChange={handleChange}
          aria-label="workspace admin sections"
        >
          {visibleTabs.map((t) => (
            <Tab key={t.value} label={t.label} value={t.value} />
          ))}
        </Tabs>
      </Box>
      <Outlet />
    </Box>
  );
};

export default WorkspacesLayout;
